<template>
  <div class="acomodar">
    <div class="mx-4 mt-4">
      <div class="row g-4">
        <div class="col-12 col-lg-3 d-flex">
          <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">
            <div class=" align-items-center">

              <div class="d-flex justify-content-between align-items-center">
                <i class="bi bi-filetype-xls text-success display-6"></i>
                <div>
                  <button v-if="!CargaReporte" class="btn btn-success px-3 py-2 shadow-sm rounded-3" 
                    @click="descargarExcel">
                    <i class="bi bi-download "></i>
                  </button>

                  <Spinner v-else/>

                </div>

                <!-- <div>
                  <button v-if="mostrarBotonDescarga" @click="descargarExcel" class="btn btn-success ps-1 py-0"
                    :disabled="cargando">
                    <i class="bi bi-file-bar-graph fs-4 me-2"></i>
                    <p v-if="!cargando">{{ progreso > 0 ? `Descargando... ${progreso}%` : 'DESCARGAR REPORTE DEMONITOREO' }}
                    </p>
                    <p v-else>Descargando... {{ progreso }}%</p>
                  </button> 
                   <div v-if="cargando" class="progress mt-2">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                      :style="{ width: progreso + '%' }" :aria-valuenow="progreso" aria-valuemin="0"
                      aria-valuemax="100">
                      {{ progreso }}%
                    </div>
                  </div> 


                </div> -->



              </div>
              <div>
                <h5 class="mt-3 mb-2 card-title text-start">Reporte de Monitoreo por Usuario</h5>

                <p class="mb-0 text-start">
                  Listado de seguimiento de acceso del usuario a la plataforma.
                </p>

              </div>
            </div>
            <form class="mt-4">
              <select id="anio" v-model="anio" class="form-select mb-3" required>
                <option value="0" disabled >--SELECCIONE EL AÑO--</option>
                <option v-for="year in anios" :key="year" :value="year">
                  {{ year }}
                </option>
              </select>

              <select :disabled="checkMes" id="mes" v-model="mes" class="form-select mb-3" required>
                <option value="0" disabled >--SELECCIONE EL MES--</option>
                <option v-for="(nombre, index) in meses" :key="index" :value="index + 1">
                  {{ nombre }}
                </option>
              </select>
              <div class="d-flex justify-content-between align-items-center">
                <label>
                  <input type="checkbox" v-model="checkMes">
                  TODOS
                </label>
              </div>

            </form>
          </div>
        </div>
        <div class="col-12 col-lg-3 d-flex">
          <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">
            <div class=" align-items-center">

              <div class="d-flex justify-content-between align-items-center">
                <i class="bi bi-filetype-xls text-success display-6"></i>

                <div>
                  <button v-if="!CargaReporte1" class="btn btn-success px-3 py-2 shadow-sm rounded-3" @click="DescargarExcelAccesos" >
                    <i class="bi bi-download "  ></i>
                  </button>

                  
                  <Spinner v-else/>
                </div>
              </div>
              <div>
                <h5 class="mt-3 mb-2 card-title text-start">Reporte de Accesos</h5>

                <p class="mb-0 text-start">
                  Listado de accesos por usuario, perfil y categoría.
                </p>

              </div>
            </div>

          </div>

        </div>
        <div class="col-12 col-lg-3 d-flex">
          <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">
            <div class=" align-items-center">

              <div class="d-flex justify-content-between align-items-center">
                <i class="bi bi-filetype-xls text-success display-6"></i>

                <div>
                  <button v-if="!CargaReporte2" class="btn btn-success px-3 py-2 shadow-sm rounded-3" @click="DescargarExcelAccesosxUsuarios" >
                    <i class="bi bi-download "></i>
                  </button>

                  <Spinner v-else/>
                </div>
              </div>
              <div>
                <h5 class="mt-3 mb-2 card-title text-start">Reporte de Usuarios</h5>

                <p class="mb-0 text-start">
                  Listado de usuarios por perfil asignado.
                </p>

              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>

</template>

<script>
import Spinner from '@/components/Spinners/Spinner.vue';
export default {
  components: { Spinner },
  name: 'PowerbyReporteBI',

  data() {
    return {
      progreso: 0,                 // Porcentaje de progreso
      anio: '0',                    // Año seleccionado
      mes: '0',                     // Mes seleccionado
      mostrarBotonDescarga: false, // Controla la visibilidad del botón de descarga
      anios: Array.from({ length: 2026 - 2010 + 1 }, (_, i) => 2010 + i), // Años de 2010 a 2025
      meses: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ] ,// Nombres de los meses
      checkMes: false,
      CargaReporte:false,
      CargaReporte1:false,
      CargaReporte2:false

    };
  },
watch: {
    checkMes(value) {
      if (value) {
        this.mes = "0";   // Limpia el mes cuando se marca "TODOS"
      }
    }
  },

  methods: {
    // validarYDescargar() {
    //   if (this.anio && this.mes) {
    //     console.log('%c🟢 Fecha validada correctamente.', 'color: green; font-weight: bold;');
    //     this.mostrarBotonDescarga = true; // Muestra el botón de descarga
    //   } else {
    //     console.error('%c🔴 Debe seleccionar un año y un mes.', 'color: red; font-weight: bold;');
    //     this.mostrarBotonDescarga = false;
    //   }
    // },

    descargarExcel() {
      this.CargaReporte = true
      this.progreso = 0;

      this.axios.get(`ReportesBI/ReporteBi`, {
        params: { anio: this.anio, mes: this.mes , checkMes: this.checkMes}, // Enviar parámetros a la API
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.total) {
            this.progreso = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            console.log(`📊 Progreso de descarga: ${this.progreso}%`);
          }
        }
      })
        .then(response => {

          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Reporte_Monitoreo_${this.anio}_${this.mes}.xlsx`;
          link.click();
          this.checkMes= false
          this.anio = '0'
          this.mes = '0'

        })
        .catch(error => {
          console.error('%c🔴 Error al conectar con la API o durante la descarga:', 'color: red; font-weight: bold;', error);
        })
        .finally(() => {
          this.CargaReporte = false
          this.progreso = 0; // Reiniciar progreso
        });
    },

    DescargarExcelAccesos(){
     this.CargaReporte1 = true
      this.axios.get(`ReportesBI/ReporteUsuario`, {       
        responseType: 'blob'      
      })
        .then(response => {

          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Reporte_Usuario_${this.anio}_${this.mes}.xlsx`;
          link.click();

        })
        .catch(error => {
          console.error('%c🔴 Error al conectar con la API o durante la descarga:', 'color: red; font-weight: bold;', error);
        })
        .finally(() => {
          this.CargaReporte1 = false

        });
    },

     DescargarExcelAccesosxUsuarios(){
      this.CargaReporte2 = true
      this.axios.get(`ReportesBI/ReporteUsuarioXacceso`, {       
        responseType: 'blob'      
      })
        .then(response => {

          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Reporte_Usuario_${this.anio}_${this.mes}.xlsx`;
          link.click();

        })
        .catch(error => {
          console.error('%c🔴 Error al conectar con la API o durante la descarga:', 'color: red; font-weight: bold;', error);
        })
        .finally(() => {
          this.CargaReporte2 = false
        });
    },
  }
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 9px;
  margin-bottom: 15px;
  padding-bottom: 5%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 0.25%;
  margin-right: 10px;
  height: 100vh;
  border-radius: 10px 10px 10px 10px;
  overflow-x: auto;
  overflow-y: auto;
  padding-top: 2%;
}

button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.progress {
  height: 20px;
  margin-top: 10px;
}

.progress-bar {
  background-color: #28a745;
}
</style>
